import { Menu } from '@mantine/core';
import IconCornerRightDown from '@tabler/icons-react/dist/esm/icons/IconCornerRightDown.mjs';
import IconCornerRightDownDouble from '@tabler/icons-react/dist/esm/icons/IconCornerRightDownDouble.mjs';
import IconCornerRightUp from '@tabler/icons-react/dist/esm/icons/IconCornerRightUp.mjs';
import IconCornerRightUpDouble from '@tabler/icons-react/dist/esm/icons/IconCornerRightUpDouble.mjs';
import { useTranslation } from 'react-i18next';
import { TreeNodeContext } from '..';

export const ExpandMenu = ({
  value,
  nodeContext,
  onItemClick,
}: {
  value: string;
  nodeContext: TreeNodeContext;
  onItemClick?: () => void;
}) => {
  const { t } = useTranslation('tree');
  const { expand, collapse, expandRecursive, collapseRecursive } = nodeContext;
  return (
    <>
      <Menu.Label>{t('expandControls.expand')}</Menu.Label>
      <Menu.Item
        onClick={(e) => {
          e.stopPropagation();
          expand(value);
          onItemClick?.();
        }}
        leftSection={<IconCornerRightDown />}
      >
        {t('expandControls.expand')}
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          e.stopPropagation();
          collapse(value);
          onItemClick?.();
        }}
        leftSection={<IconCornerRightUp />}
      >
        {t('expandControls.collapse')}
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          e.stopPropagation();
          expandRecursive(value);
          onItemClick?.();
        }}
        leftSection={<IconCornerRightDownDouble />}
      >
        {t('expandControls.expandRecursively')}
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          e.stopPropagation();
          collapseRecursive(value);
          onItemClick?.();
        }}
        leftSection={<IconCornerRightUpDouble />}
      >
        {t('expandControls.collapseRecursively')}
      </Menu.Item>
    </>
  );
};